<div class="sp-company-details-general__grid sp-min-height__full">
  <app-company-details-general-info
    *ngIf="!(is_read_running || is_qinetic_ps_list_running || is_stripe_ps_list_running || is_list_running)"
    class="sp-company-details-general__info"
    (refresh)="refresh.emit()"
    [company]="company"></app-company-details-general-info>

  <app-company-details-general-payment-methods
    *ngIf="!(is_read_running || is_qinetic_ps_list_running || is_stripe_ps_list_running || is_list_running)"
    [qinetic_payment_sources]="qinetic_payment_sources"
    [stripe_payment_sources]="stripe_payment_sources"></app-company-details-general-payment-methods>

  <app-company-details-general-contracts
    *ngIf="!(is_read_running || is_qinetic_ps_list_running || is_stripe_ps_list_running || is_list_running)"
    (refresh)="refresh.emit()"
    [company]="company"
    [contracts]="contracts"></app-company-details-general-contracts>

  <app-company-details-general-settings
    class="sp-company-details-general__settings"
    (refresh)="refresh.emit()"
    *ngIf="!(is_read_running || is_qinetic_ps_list_running || is_stripe_ps_list_running || is_list_running)"
    [company]="company"
    [company_long_ranges]="company_long_ranges"
    [default_long_ranges]="default_long_ranges"></app-company-details-general-settings>

  <app-loading
    *ngIf="is_read_running || is_qinetic_ps_list_running || is_stripe_ps_list_running || is_list_running"
    class="sp-company-details-general__info sp-company-details-general__loading"></app-loading>

  <app-loading
    *ngIf="is_read_running || is_qinetic_ps_list_running || is_stripe_ps_list_running || is_list_running"
    class="sp-company-details-general__loading"></app-loading>

  <app-loading
    *ngIf="is_read_running || is_qinetic_ps_list_running || is_stripe_ps_list_running || is_list_running"
    class="sp-company-details-general__loading"></app-loading>

  <app-loading
    *ngIf="is_read_running || is_qinetic_ps_list_running || is_stripe_ps_list_running || is_list_running"
    class="sp-company-details-general__settings sp-company-details-general__loading"></app-loading>
</div>
